import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useLocation } from 'react-router-dom';

import SectionBreakTitle, { SectionColor } from '@components/SectionBreakTitle';
import { useCurrentUser } from '@hooks';

import AddTopicForm from './AddTopicForm';
import TopicList from './TopicList';

const queryClient = new QueryClient();

const EditTopicsSettings = () => {
  const { currentUser } = useCurrentUser();
  const { pathname } = useLocation();

  return (
    <QueryClientProvider client={queryClient}>
      {pathname === '/settings/topics' ? (
        <>
          <SectionBreakTitle
            className="mb-32"
            titleClassName="text-primary-magenta"
            color={SectionColor.Magenta}
            title="Topics"
          />
          <div className="mb-24 font-suisse-intl text-description-lg">
            Select areas of interest to get custom updates.
          </div>
        </>
      ) : (
        <div className="prefs-section-header">
          <h3>Topics you follow on The Information</h3>
        </div>
      )}

      <AddTopicForm identityId={currentUser.identity_id} />
      <TopicList identityId={currentUser.identity_id} />
    </QueryClientProvider>
  );
};

export default EditTopicsSettings;
